<app-modal
  [showModal]="showIdleWarning"
  [componentData]="componentData"
  (closeModal)="closeWarningModal()"
  (btnCallback1)="signOut()"
  (btnCallback2)="continueSession()"
></app-modal>
